import ls from 'localstorage-slim'

import { Theme } from '@ankor-io/common/types/account'

/**
 * Toggle between light and dark mode
 * @param toMode Theme enum
 */
export const updateThemeMode = (toMode: Theme) => {
  ls.set('prefers-color-scheme', toMode)
  const isDark = toMode === Theme.DARK
  if (isDark) {
    document.documentElement.classList.add(Theme.DARK)
  } else {
    document.documentElement.classList.remove(Theme.DARK)
  }

  // Keep html/body inline backgrounds in sync with the active theme.
  // This prevents mismatched backgrounds when scrolling within inner containers.
  const darkBg = 'rgb(17, 24, 39)'
  const lightBg = 'rgb(255, 255, 255)'
  const bgColour = isDark ? darkBg : lightBg
  try {
    document.documentElement.style.backgroundColor = bgColour
    if (document.body) {
      document.body.style.backgroundColor = bgColour
    }
  } catch (error) {
    console.error('Error updating theme mode', error)
  }
}
